/**
 * Slick carousel enhancements.
 */
"use strict";

(function($) {
  //var alreadyRan = false;
  var updateDetails = function(slideIndex, slick) {
    // In the process of responding, the overlays may become detached from the
    // slider. Check and correct that.
    if (!slick.$overlays.parents('.slick-slider').length) {
      slick.$overlays.appendTo(slick.$slider.find('.slick-list'));
    }
    var slideObject = slick.$slides[slideIndex];
    // Add the new content to the "previous" (currently hidden) details pane.
    slick.$overlays.filter('.slide-details-prev')
      .html($('.content', slideObject).html())
      // Set even/odd classes.
      .toggleClass('slide-details-even', slideIndex % 2 === 0)
      .toggleClass('slide-details-odd', slideIndex % 2 === 1);
    // Swap the previous/next classes on the panes, which will trigger a
    // transition.
    slick.$overlays
      .toggleClass('slide-details-prev slide-details-next');
    ytmodal();
  };

  // Slick carousel initialization steps.
  $(document.body).on('init', '.paragraph--type--content-carousel', function(event, slick) {

    // slickGetOption
    //  option : string
    // slickSetOption
    //  option : string, value : depends on option, refresh : boolean

    // Add Details overlay.
    slick.$overlays = $('<div class="slide-details slide-details-prev h3"></div><div class="slide-details slide-details-next h3"></div>')
      .appendTo(slick.$slider.find('.slick-list'));
    // Update Details overlay.
    updateDetails(slick.slickCurrentSlide(), slick);
  });

  $(document.body).on('beforeChange', '.paragraph--type--content-carousel', function(event, slick, currentSlide, nextSlide) {
    // Update Details overlay.
    updateDetails(nextSlide, slick);
  });

  // show.slickLightbox   Triggered when the lightbox is opened.
  // shown.slickLightbox  Triggered when the lightbox is opened, after the transitions took place.
  // hide.slickLightbox   Triggered when the lightbox is closed.
  // hidden.slickLightbox   Triggered when the lightbox is closed, after the transitions took place.

  // Play embedded video when the lightbox is opened.
  $(document.body).on('show.slickLightbox', function(e) {
    var target = e.target || e.srcElement;
    if (target.slickLightbox && target.slickLightbox.$modalElement) {
      setTimeout(function() { target.slickLightbox.$modalElement.find('.media__icon--play').click(); }, 300);
    }
    // Target is the original element, from which we can gather things like
    // transcripts.
    if (target && target.slickLightbox && target.slickLightbox.$modalElement) {
      target.slickLightbox.$modalElement.find('.media__icon--play', target).click();
      var transcript = target.slickLightbox.$element.find('[data-transcript]').attr('data-transcript'),
        transcript_override = target.slickLightbox.$element.parents('[data-transcript-override]').attr('data-transcript-override');
      if (transcript_override) {
        transcript = JSON.parse(transcript_override);
      }
      else if (transcript) {
        transcript = JSON.parse(transcript);
      }
      else {
        transcript = false;
      }
      // Always remove the transcript element, assuming it is stale (or there is
      // no new transcript).
      target.slickLightbox.$modalElement
        .toggleClass('slick-lightbox-has-transcript', !!transcript)
        .find('.slick-lightbox-transcript').remove();
      // Add the transcript back, if applicable.
      if (transcript) {
        $('<details class="slick-lightbox-transcript">')
          .html(transcript)
          .prepend('<summary>Transcript</summary>')
          .appendTo(target.slickLightbox.$modalElement.find('.slick-lightbox-slick-item-inner'));
      }
    }
  });

/*
  $('button.slick-next').on('click', function() {
    console.log('next');

    $('.slide-details a').each(function(i,elem) {

      var btnurl = $(elem).attr('href');

      if (btnurl.includes('youtube.com') || btnurl.includes('youtu.be')) {
        var ytid = 'dQw4w9WgXcQ';
        // get the youtube video id

        var match = btnurl.match(regExp);
        if (match && match[2].length == 11) {
          ytid = match[2];
          $(elem).attr('href', 'https://www.youtube.com/embed/' + ytid + '?rel=0&wmode=transparent');
          //$(elem).attr('href', '/media/oembed?url=https%3A//www.youtube.com/watch%3Fv%3DS1gG6TwDilc%26ab_channel%3DLawrenceUniversity&max_width=0&max_height=0&hash=HQsi6xd5Q7LIiTgiM-W6P8tM86z8LplWDrWDGNXZEpI&blazy=1&autoplay=1')
          var w = ($(document).width() * .8) + 'px';
          var h = ($(document).height() * .8) + 'px';
          $(elem).colorbox({iframe:true, innerWidth:w, innerHeight:h, maxWidth:"1800px", maxHeight:"900px"});
        } else {
          //error
        }
      }
    });
  });
*/

  /*
  // hack to fix this CRITICAL issue of needing a YouTube video open in a modal window
  */

  // This almost same script it scripts.js, but necesary here because it needs
  // to run AFTER the carousel content manipulation in this script in the
  // updateDetails() function. Different in what elements it keys on in the
  // ytmodal() function.

  function isThisMobile() {
    if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)) {
      return true;
    }
    return false;
  }

  function ytfixbtn(elem) {

    var btnurl = $(elem).attr('href');

    if (btnurl.includes('youtube.com') || btnurl.includes('youtu.be')) {

      // get the youtube video id
      var ytid = 'dQw4w9WgXcQ';
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = btnurl.match(regExp);

      if (match && match[2].length == 11) {
        ytid = match[2];
        $(elem).attr('href', 'https://www.youtube.com/embed/' + ytid + '?rel=0&wmode=transparent&autoplay=1');
        if(isThisMobile()) {
          $(elem).colorbox({iframe:true, width:"90%", height:"75%", scrolling:false, overlayClose:true, opacity:0.5, close:"Close", closeButton:false});
        } else {
          $(elem).colorbox({iframe:true, width:"75%", height:"75%", scrolling:false, overlayClose:true, opacity:0.5, close:"Close", closeButton:false});
        }
      } else {
        //error
      }
    }
  }

  function ytmodal() {

    /*
    if (alreadyRan) {
      //return;
    }
    alreadyRan = true;
    */

    //console.log('ytmodal slick_carousel.js');

    // carousel content desktop
    $('.slide-details a').each(function(i,elem) {
      ytfixbtn(elem);
    });

    // carousel content mobile
    $('.slick__slide a').each(function(i,elem) {
      ytfixbtn(elem);
    });

    // fix the colorbox overlay
    $('#cboxOverlay').css('height', $(document).height() + 'px');
    $('#cboxOverlay').css('width', $(document).width() + 'px');
  }

  // I couldn't get Slick UI options right so I gave up and decided to just do
  // it with bare metal JS.
  Drupal.behaviors.lu_slick_carousel = {
    attach: function(context, settings) {
      // Only run this bit if we actually have SlickLightbox on this page -
      // we may sometimes have Slick carousels without the Lightbox plugin.
      if (typeof $.fn.slickLightbox !== 'undefined') {
        $('.field--name-field-gallery-contents', context).slickLightbox({
          caption: 'caption'
        });
      }
    }
  };

})(jQuery);
